import React, {useEffect} from 'react';

import './Target.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";


function TargetPlaySpell({tableKey, table, side, action}:any) {

    const {phase, playedCard} = useTypedSelector(state => state.game);
    const {playCard, setPlayedCard, setPhase} = useActions();

    let targetClasses = 'tableSpellTarget';
    let showPlaySpellTarget = false;


    const shouldAnimate =
        phase === 'select_spell_target' &&
        playedCard.card !== null &&
        playedCard.target === null &&
        table[tableKey] !== 0 &&
        table[tableKey] !== null &&
        (side === playedCard.card?.ability.side_target || playedCard.card?.ability.side_target === 'both') &&
        (playedCard.card?.ability.aim_target === 'unit' || playedCard.card?.ability.aim_target === 'unit_castle');


    if (shouldAnimate) {
        targetClasses += ' tableTargetActive';
        showPlaySpellTarget = true;
    }

    useEffect(() => {
        if (shouldAnimate) {
            action('animateCardBoxShadowDiscard');
        }else{
            action('');
        }
    }, [shouldAnimate]);

    const setTargetAndSpellUnit = function(){
        action('');
        playedCard.target = {key:'table_key', value:tableKey, side:side};
        playCard(playedCard);

        setPlayedCard({card:null, handKey:null, target:null});
        setPhase('play_spell');
    }

    return (
        <div className={targetClasses}>
            <div className={'clickPlaySpellTarget'}  onClick={()=>{
                if(showPlaySpellTarget){
                    setTargetAndSpellUnit();
                }
            }}></div>

        </div>
    );
}

export default TargetPlaySpell;
